exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-responsive {\n  position: relative;\n  overflow: hidden;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.v-responsive__content {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 0px;\n          flex: 1 0 0px;\n}\n.v-responsive__sizer {\n  -webkit-transition: padding-bottom 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);\n  transition: padding-bottom 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 0px;\n          flex: 0 0 0px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/src/stylus/components/_responsive.styl
// module id = f2Ia
// module chunks = 1